import { Actions } from './Actions'
import { Content } from './Content'
import { Header } from './Header'

/**
 * @deprecated
 */
export const Overlay = { Content, Header, Actions }
